import { z } from 'zod';
import { accountsType, apiResponseType, loanProviderRequest, loanResponseStatus, loanStage, providerType, loanIdSchema, moneySchema, periodSchema, requestIdSchema, timestampSchema, } from '@repo/shared/types';
import { internalErrorResponseSchema, loanDataNotFoundResponseSchema, loanResponseBaseSchema, redisKeyNotFoundResponseSchema, } from './loan-shared.schema';
export var loanEditRequestBodySchema = z.object({
    requestId: requestIdSchema,
    provider: providerType,
    loanId: loanIdSchema,
    data: z.object({
        loanRepaymentAccounts: accountsType.optional(),
        amount: moneySchema.optional(),
        period: periodSchema.optional(),
    }),
});
// Response code 200
export var loanEditSuccessResponse = loanResponseBaseSchema.and(z.object({
    requestId: requestIdSchema,
    timestamp: timestampSchema,
    type: apiResponseType,
    data: z.object({
        loanId: loanIdSchema,
        status: loanResponseStatus,
        providerRequest: loanProviderRequest,
        stage: loanStage,
    }),
}));
// Response code 400
export var loanEditRedisKeyNotFoundResponseSchema = redisKeyNotFoundResponseSchema;
// Response code 404
export var loanEditDataNotFoundResponseSchema = loanDataNotFoundResponseSchema;
// Response code 500
export var loanEditInternalErrorResponseSchema = internalErrorResponseSchema;
